import {createSelectList} from '../utils'
import GenerateEnum from '../generateEnum'
import {getLabelText} from '../utils'

// 模块类型 1活动模块 2商品模块 3领券模块 4自定义模块
const MODULE_TYPE = {
    ACTIVITY: 1,
    GOODS: 2,
    COUPON: 3,
    CUSTOM: 4
}

const MODULE_TYPE_MAP = {
    [MODULE_TYPE.ACTIVITY]: getLabelText({key: 'remote.common.activityModule', text: '活动模块'}),
    [MODULE_TYPE.GOODS]: getLabelText({key: 'remote.common.productModule', text: '商品模块'}),
    [MODULE_TYPE.COUPON]: getLabelText({key: 'remote.common.couponModule', text: '领券模块'}),
    [MODULE_TYPE.CUSTOM]: getLabelText({key: 'remote.common.customModule', text: '自定义模块'})
}

const MODULE_TYPE_LIST = createSelectList({
    constants: MODULE_TYPE,
    map: MODULE_TYPE_MAP
})

// 关联活动类型 1秒杀 2拼团 3新人专区 4万人团
const REL_ACTIVITY_TYPE = {
    SECKILL: 1,
    GROUP: 2,
    NEW: 3,
    TEN_THOUSAND: 4,
    PRICES_FOLDS: 5
}

const REL_ACTIVITY_TYPE_MAP = {
    [REL_ACTIVITY_TYPE.SECKILL]: getLabelText({key: 'remote.common.secondKill', text: '秒杀'}),
    [REL_ACTIVITY_TYPE.GROUP]: getLabelText({key: 'remote.common.joinAGroup', text: '拼团'}),
    [REL_ACTIVITY_TYPE.NEW]: getLabelText({key: 'remote.common.newcomerArea', text: '新人专区'}),
    [REL_ACTIVITY_TYPE.TEN_THOUSAND]: getLabelText({key: 'remote.common.tenThousandPeople', text: '万人团'}),
    [REL_ACTIVITY_TYPE.PRICES_FOLDS]: getLabelText({
        key: 'remote.common.multiplePiecesAndMultipleFolds',
        text: '多件多折扣'
    })
}

const REL_ACTIVITY_TYPE_LIST = createSelectList({
    constants: REL_ACTIVITY_TYPE,
    map: REL_ACTIVITY_TYPE_MAP
})

// 每行显示数量
const PER_ROW_COUNT_LIST = [2, 3, 4]

// 模块状态 0:未开始,1:进行中,2:已结束
const MODULE_STATUS = {
    NOT_START: 0,
    PROCESSING: 1,
    FINISHED: 2
}

const MODULE_STATUS_MAP = {
    [MODULE_STATUS.NOT_START]: getLabelText({key: 'remote.common.notStarted', text: '未开始'}),
    [MODULE_STATUS.PROCESSING]: getLabelText({key: 'remote.common.inProgress', text: '进行中'}),
    [MODULE_STATUS.FINISHED]: getLabelText({key: 'remote.common.ended', text: '已结束'})
}

// 是否有效 0：撤销 1：创建成功
const CFG_STATUS = {
    REVOKE: 0,
    SUCCESS: 1
}

const CFG_STATUS_MAP = {
    [CFG_STATUS.REVOKE]: getLabelText({key: 'remote.common.revoked', text: '已撤销'}),
    [CFG_STATUS.SUCCESS]: getLabelText({key: 'remote.common.creationSuccessful', text: '创建成功'})
}

const CFG_STATUS_LIST = createSelectList({
    constants: CFG_STATUS,
    map: CFG_STATUS_MAP
})

// 领取方式 1：立即领取 2：跳转引流
const RECEIVE_WAY = {
    RECEIVE_IMMEDIATELY: 1,
    REDIRECT: 2
}

const RECEIVE_WAY_MAP = {
    [RECEIVE_WAY.RECEIVE_IMMEDIATELY]: getLabelText({key: 'remote.common.getItNow', text: '立即领取'}),
    [RECEIVE_WAY.REDIRECT]: getLabelText({key: 'remote.common.redirectTraffic', text: '跳转引流'})
}

const RECEIVE_WAY_LIST = createSelectList({
    constants: RECEIVE_WAY,
    map: RECEIVE_WAY_MAP
})
const VOUCHER_STATUS = {
    INACTIVATED: '0',
    UNUSED: '1',
    USED: '2',
    EXPIRED: '3',
    ABOLISHED: '4',
    LOSE_EFFICACY: '5',
    NOT_AVAILABLE: '6'
}
//奖励类型
const AWARD_TYPE = {
    COUPONS: 0, //立减券
    COUPON_PACKAGE: 1, //券包
    SERVICE_COUPON: 2, //服务兑换券
    FULL_REDUCTION: 3, //满减券
    BONUS_POINTS: 4 //奖励积分
}
// sessionStorage的key
const SS_KEY = {
    userList: 'userList', // 选择账号列表
    activityType: 'activityType', // 老带新、推荐官计划、轮盘抽奖的活动类型
    loginedRoute: 'loginedRoute' // 登录、注册后要跳转到的路由参数（同$router.push的参数）
}

// CALENDAR(1, "日历"),  TEXT(2, "文案"),
const CALENDAR_TYPE_ENUM = new GenerateEnum({
    CALENDAR: {
        value: 1,
        label: getLabelText({key: 'remote.common.activityCalendar', text: '活动日历'})
    },
    TEXT: {
        value: 2,
        label: getLabelText({key: 'remote.common.copywritingIntroduction', text: '文案简介'})
    }
})

const HEADER_IMG_TYPE = new GenerateEnum({
    CUSTOM: {
        value: 2,
        label: getLabelText({key: 'remote.admin.custom', text: '自定义'})
    },
    NONEDD: {
        value: 3,
        label: getLabelText({key: 'remote.admin.none', text: '无'})
    }
})
const HEADER_USE_TYPE = new GenerateEnum({
    //默认
    DEFAULT: {
        value: 1
    },
    //预告中
    TRAILER: {
        value: 2
    },
    //进行中
    PROGRESS: {
        value: 3
    }
})

// 主体信息关系 - 商户方付款
const AGREEMENT_SIGN_PAYMENT_ENUM = new GenerateEnum({
    SHAREHOLDER: {
        value: 0,
        label: '股东或股东关联方'
    },
    STAFF: {
        value: 1,
        label: '员工或所属集团的员工'
    },
    SERVICE_PROVIDER: {
        value: 2,
        label: '服务提供商（代理）'
    }
})

// 主体信息关系 - 公司方付款
const AGREEMENT_SIGN_COMPANY_ENUM = new GenerateEnum({
    NATURAL_PERSON: {
        value: 0,
        label: '同一控制下的关联公司或关联自然人'
    },
    SERVICE_PROVIDER: {
        value: 1,
        label: '服务提供商（代理）'
    }
})

export {
    HEADER_USE_TYPE,
    HEADER_IMG_TYPE,
    MODULE_TYPE,
    MODULE_TYPE_MAP,
    MODULE_TYPE_LIST,
    REL_ACTIVITY_TYPE,
    REL_ACTIVITY_TYPE_MAP,
    REL_ACTIVITY_TYPE_LIST,
    PER_ROW_COUNT_LIST,
    MODULE_STATUS,
    MODULE_STATUS_MAP,
    CFG_STATUS,
    CFG_STATUS_MAP,
    CFG_STATUS_LIST,
    RECEIVE_WAY,
    RECEIVE_WAY_MAP,
    RECEIVE_WAY_LIST,
    VOUCHER_STATUS,
    AWARD_TYPE,
    SS_KEY,
    CALENDAR_TYPE_ENUM,
    AGREEMENT_SIGN_PAYMENT_ENUM,
    AGREEMENT_SIGN_COMPANY_ENUM
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/ActivityPageCfg.js